export type ProductReviewContainerProps<ReviewType = unknown> = {
  title?: string;
  productId: string;
  productReviewsAverage?: ReviewType;
};
